import React from "react";
import { normalizeUrl, trimTrailingUrlCharacters, URL_PATTERN } from "./linkify";

export function renderMessageText(
  text,
  { keyPrefix = "message-text", linkStyle = {} } = {},
) {
  const safeText = `${text || ""}`;
  if (!safeText) return null;

  const lines = safeText.split("\n");
  const parts = [];

  lines.forEach((line, lineIndex) => {
    URL_PATTERN.lastIndex = 0;

    let lastIndex = 0;
    let tokenIndex = 0;
    let match;

    while ((match = URL_PATTERN.exec(line)) !== null) {
      if (match.index > lastIndex) {
        parts.push(line.slice(lastIndex, match.index));
      }

      const rawUrl = match[0];
      const { url, trailingText } = trimTrailingUrlCharacters(rawUrl);

      if (url) {
        parts.push(
          <a
            key={`${keyPrefix}-link-${lineIndex}-${tokenIndex}`}
            href={normalizeUrl(url)}
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            {url}
          </a>,
        );
      } else {
        parts.push(rawUrl);
      }

      if (trailingText) {
        parts.push(trailingText);
      }

      lastIndex = match.index + rawUrl.length;
      tokenIndex += 1;
    }

    if (lastIndex < line.length) {
      parts.push(line.slice(lastIndex));
    }

    if (lineIndex < lines.length - 1) {
      parts.push(<br key={`${keyPrefix}-br-${lineIndex}`} />);
    }
  });

  return parts;
}
